import { ENCRYPT_STORAGE, BuildVersion, currentver } from "../../config/config";
import { STORE_MERCHANT_SCROLL } from "../../database/store-names";
import { GET_SET_STORED_DATA } from "../../database/get-stored-data";
import { dto_Customer } from "../../classes/dto-customer";
import { PT_DAITONN } from "../../routes/stack/paths/pt-profile";
import { F_Fammily } from "../../util/config-fonts";
import { Colors } from "../../util/colors";
import ViewHeaderSection from "./components/header-section/header-section";
import ViewMenuList from "./components/menu-list/menu-list";
import React from "react";
import "../../styles/css/pg-profile-footer.css";

const FAILOVER_STATE_KEY = "ApiFailoverState";

const getApiServerTag = () => {
  try {
    const raw = window.localStorage.getItem(FAILOVER_STATE_KEY);
    if (!raw) {
      return "S1";
    }
    const parsed = JSON.parse(raw);
    const fallbackUntil = Number(parsed?.fallbackUntil) || 0;
    return Date.now() < fallbackUntil ? "S2" : "S1";
  } catch (_error) {
    return "S1";
  }
};

export default class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      CSID: 0,
    };
  }

  async componentDidMount() {
    await GET_SET_STORED_DATA();
    this.setState({ CSID: dto_Customer.CSID });
    ENCRYPT_STORAGE.removeItem(STORE_MERCHANT_SCROLL);
  }

  render() {
    const apiServerTag = getApiServerTag();
    return (
      <div
        className="fadeInUp animated"
        style={{
          height: "100vh",
        }}
      >
        <ViewHeaderSection
          CSID={this.state.CSID}
          navigate={this.props.navigate}
        />
        <ViewMenuList CSID={this.state.CSID} navigate={this.props.navigate} />
        <div
          className="pgProfileFooter"
          style={{
            left: 0,
            right: 0,
            marginTop: 0,
            position: "absolute",
            bottom: 60,
            textAlign: "center",
          }}
        >
          <p
            style={{
              margin: 0,
              textAlign: "center",
              fontSize: 12,
              color: "#969696",
            }}
          >
            App version {currentver} | Build version {BuildVersion} ({apiServerTag})
          </p>
          <div
            style={{
              margin: 0,
              textAlign: "center",
              fontSize: 10,
              color: "#969696",
              display: "block",
            }}
          >
            Powered by{" "}
            <div
              style={{
                fontFamily: F_Fammily.Medium,
                color: Colors.ThemeBGcolor,
              }}
              onClick={() => {
                this.props.navigate(PT_DAITONN);
              }}
            >
              <b>
                {" "}
                <span style={{ fontSize: 12 }}>DAITONN</span>
              </b>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
